import { useDependencies } from '@/scenarios/legacy-player/hooks/analytics/use-dependencies';

interface UiParams {
    channelId: string;
}

interface Params {
    uiParams: UiParams;
    dependencies: ReturnType<typeof useDependencies>;
}

export function buildChannelProgramModalParams({ uiParams, dependencies }: Params) {
    const { getPlayerBaseInfo } = dependencies;

    const baseInfo = getPlayerBaseInfo();
    const title = baseInfo?.content?.__typename === 'TvChannel' ? baseInfo.content.title : '';

    return {
        channelName: title,
        ...uiParams,
    };
}
